import { Avatar } from '@community_dev/pixels'
import styled from 'styled-components'

export const StyledAvatar = styled(Avatar)`
  margin-left: 4px;
  background: #f4f4f4;
  img {
    width: 80%;
  }
`

export const StyledLogoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

export const StyledCross = styled.span`
  &::before {
    content: '+ ';
    ${({ theme }) => theme?.TYPOGRAPHY?.VARIANT?.H2};
    color: ${({ theme }) => theme?.COLORS?.SUBTEXT};
  }
  margin: 0 5px;
`

export const StyledLink = styled.a`
  text-decoration: none;
  color: ${({ theme }) => theme?.COLORS.LINKS};
`
